import React, { useState } from "react";
import { toast } from "react-toastify";
import "./Styles/login.css";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false); // Added loading state
  const navigate = useNavigate();
  const handleLogin = async () => {
    try {
      // Perform client-side validation if needed (e.g., check for empty fields)

      // Prepare the login data
      const loginData = {
        email,
        password,
      };

      // Set loading state to true to display the loading indicator
      setLoading(true);

      // Make an API request to the login endpoint
      const response = await fetch(
        "https://fine-cyan-chipmunk-shoe.cyclic.app//api/user/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(loginData),
        }
      );

      const data = await response.json();

      if (response.status === 400) {
        toast.error(data.message);
      } else {
        toast.success("Login successful");
        localStorage.setItem("x_token", data.token);
        navigate("/admin/dashboard");
      }
    } catch (error) {
      toast.error("API Error:", error.message);
    } finally {
      // Set loading state back to false after the API request is completed
      setLoading(false);
    }
  };

  return (
    <div className="login">
      <h2>Login</h2>
      <div>
        <label>Email:</label>
        <input
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Password:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <div>
        <button onClick={handleLogin}>Login</button>
      </div>

      {loading && <div className="loading-indicator">Loading...</div>}
    </div>
  );
};

export default Login;
